import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { DataService } from '../../user-detail.service';

@Injectable({
  providedIn: 'root'
})
export class BreaktimecebuGuard implements CanActivate {

  constructor(
    private router: Router,
    private dataService: DataService
  ){}
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let branches = this.dataService.getStaffInformation.branches.map(branch => branch['name']);

    if (branches.includes('セブ支店')) {
        return true;
    } else {
        this.router.navigate(['/attendance-record']);
        return false;
    }
}
}
